import { showToast } from '../store/toastStore';

export async function copyToClipboard(
  text: string,
  successMessage = 'Copied to clipboard',
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    showToast(successMessage, 'success');
    return true;
  } catch {
    showToast('Failed to copy to clipboard', 'error');
    return false;
  }
}
